import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=29d82319&scoped=true"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&id=29d82319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d82319",
  null
  
)

export default component.exports